import { OrderResultType } from './order-result-type';

export class OrderResultModel {
    orderId: number;
    success: boolean;
    message: string;
    context: OrderResultType;
}
